/**
 * @generated SignedSource<<0aedd1f442f855194927e1a57502194d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreFlag = "Calendar" | "CustomerFeedback" | "EmployeeRole" | "GroupAccountsAndProfiles" | "MigratedTeamSchedule" | "OnbardedTeams" | "Product" | "ProductDateTracker" | "SignalWidget" | "TodoAsIssue" | "TodoNewTimlineAndComments" | "VersionSummer24";
export type StoreSuperAdminPanelDisableFlagMutation$variables = {
  flag: StoreFlag;
  storeId: string;
};
export type StoreSuperAdminPanelDisableFlagMutation$data = {
  readonly store: {
    readonly _adminEnableFlag: {
      readonly flags: ReadonlyArray<StoreFlag>;
    };
  };
};
export type StoreSuperAdminPanelDisableFlagMutation$rawResponse = {
  readonly store: {
    readonly _adminEnableFlag: {
      readonly flags: ReadonlyArray<StoreFlag>;
      readonly id: string;
    };
  };
};
export type StoreSuperAdminPanelDisableFlagMutation = {
  rawResponse: StoreSuperAdminPanelDisableFlagMutation$rawResponse;
  response: StoreSuperAdminPanelDisableFlagMutation$data;
  variables: StoreSuperAdminPanelDisableFlagMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flag"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "flag",
    "variableName": "flag"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flags",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreSuperAdminPanelDisableFlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "_adminEnableFlag",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StoreSuperAdminPanelDisableFlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "_adminEnableFlag",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "051b918282a1edf184034538f7834954",
    "id": null,
    "metadata": {},
    "name": "StoreSuperAdminPanelDisableFlagMutation",
    "operationKind": "mutation",
    "text": "mutation StoreSuperAdminPanelDisableFlagMutation(\n  $storeId: ID!\n  $flag: StoreFlag!\n) {\n  store(id: $storeId) {\n    _adminEnableFlag(flag: $flag) {\n      flags\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "58c05032094d5420d349f1873480ecfb";

export default node;
